// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"531":"2e4b2b17","633":"416bef22","884":"1ba54f60"}[chunkId] + ".chunk.css";
};